import React, { useState, useRef, useEffect } from "react";
import "./ShareAssetPopup.css";
import { getOrganizationConnection, getshareaccessforasset, removeshareaccessforasset, sharedAssetRequest } from "Config/API/get";
import { toast } from "react-toastify";
import demo from "Media/blank-profile-picture.png";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { renderOrganizationInfo } from "Redux/action/render.action";
const ShareAssetPopup = ({ hide, assetId }) => {
  const token = localStorage.getItem("token");
  const [orgName, setOrgName] = useState('');
  const [org, setOrg] = useState([]); // Store the array of organizations directly
  const [showOrg, setShowOrg] = useState(false);
  const shareassetRef = useRef(null);
  const uniqueid = useSelector((state) => state.assetIdReducer);
  const navigate = useNavigate();
  const dispatch = useDispatch()
    const [sharedList, setSharedList] =useState([])
  const [connId, setConnId] = useState('')
    const general_info = useSelector((state) => state.renderGeneralInfo);
  
  const handleInputChange = async (e) => {
    const value = e.target.value;
    setOrgName(value);
    setShowOrg(true);

    try {
      const orgData = await getOrganizationConnection(token, general_info?.org_id);

      const filteredOrgs = (orgData?.organizationData || []).filter((org) =>
        org.organization_name.toLowerCase().includes(value.toLowerCase())
      );


      setOrg(filteredOrgs);
    } catch (error) {
      console.error("Error fetching organizations:", error);
    }
  };
    const fetchSharedList = async () => {
      try {
        const sharedaccesslist = await getshareaccessforasset(token, assetId);
        if (sharedaccesslist.status === true) {
          setSharedList(sharedaccesslist.data?.sharedOrgs || []);

        } else {
          toast.error("failed to fetch shared organization access list")
        }

      } catch (error) {
        console.error("failed to fetch shared organization access list", error);
      }
    };
  // Fetch shared organizations list
  useEffect(() => {
    if (!assetId) return;

  

    fetchSharedList();
  }, [assetId]);
const [showConfirmPopup, setShowConfirmPopup] = useState(false);
const [selectedOrgId, setSelectedOrgId] = useState(null);
const confirmRemoveAccess = (orgId) => {
  setSelectedOrgId(orgId);
  setShowConfirmPopup(true);
};
const handleConfirmDelete = async () => {
  if (!selectedOrgId) return;

  try {
    const shareaccessremoval = await removeshareaccessforasset(
      token, 
      assetId, 
      selectedOrgId
    );

    if (shareaccessremoval.status === true) {
      setSharedList((prev) => prev.filter((org) => org.id !== selectedOrgId));
      fetchSharedList();
    } else {
      toast.error("Failed to remove organization");
    }
  } catch (error) {
    console.error("failed to remove organization", error);
  } finally {
    setShowConfirmPopup(false);
    setSelectedOrgId(null);
  }
};
const handleCancelDelete = () => {
  setShowConfirmPopup(false);
  setSelectedOrgId(null);
};

  const handleRemoveAccess = async (orgId) => {
    try {
      const shareaccessremoval = await removeshareaccessforasset(token, assetId, orgId)
      if (shareaccessremoval.status === true) {
        setSharedList((prev) => prev.filter((org) => org.id !== orgId));
         fetchSharedList()
      } else {
        toast.error("failed to remove organization")
      }

    } catch (error) {
      console.error("failed to remove organization", error);
    }
  };

  // Show dropdown on input field click if empty
  const handleInputClick = async () => {
    if (!orgName.length) {
      const orgData = await getOrganizationConnection(token, general_info?.org_id);
      setOrg(orgData?.organizationData || []); // Use fallback array if undefined
    }
    setShowOrg(true);
  };

  // Hide dropdown if user clicks outside the dropdown or input field
  const handleOutsideClick = (event) => {
    if (shareassetRef.current && !shareassetRef.current.contains(event.target)) {
      setShowOrg(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  const handleSubmit = async () => {
    if (!orgName) {
      toast.error("Please enter an organization name.");
      return; // Exit early if orgName is empty
    }
    try {
      const sharedRequest = await sharedAssetRequest(token, assetId, connId);

      if (sharedRequest.status === true) {
        toast.success(sharedRequest.message);
        hide(false)
      } else {
        toast.error(sharedRequest.message);
      }
    } catch (error) {
      toast.error("An error occurred. Please try again.");
      console.error("Error in handleSubmit:", error);
    }
  };
  return (
    <div className="share-asset-overlay">
      <div className="share-asset-container">
        <div className="share-asset-header">
          <span>Share Asset</span>
          <button className="close-asset-sharing-popup" onClick={() => hide(false)}>
            X
          </button>
        </div>

        <div className="share-asset-dropdown">
          <label>Select Organization</label>
          <div className="sharing-list" ref={shareassetRef}>
            <input
              type="text"
              placeholder="Enter organization name"
              value={orgName}
              onChange={handleInputChange}
              onClick={handleInputClick}
              required
            />
            {showOrg && (
              <div className="organization-list asset-list">
                {org.length > 0 ? (
                  org.map((vendor, index) => (
                    <div
                      className="data-list"
                      key={index}
                      onClick={() => {
                        setOrgName(vendor.organization_name);
                        setConnId(vendor.org_id)
                        setShowOrg(false);
                      }}
                    >
                      <div className="organization-img-parent">

                        <img
                          src={vendor.logo || demo}
                          alt="vendor"
                          onError={(e) => {
                            e.target.onerror = null; // Prevent infinite loop
                            e.target.src = demo; // Fallback to demo image
                          }}
                        />
                      </div>
                      <span className="multiple-line-text">
                        {vendor.organization_name || "No Name"}
                      </span>
                    </div>
                  ))
                ) : (
                  null
                )}
              </div>
            )}
          </div>
          <button className="share-btn" onClick={handleSubmit}>Share</button>
        </div>
        <div className="asset-shared-org-list">
          <span>Access Shared</span>
       <div className="shared-table">

    {/* Header Row */}
    {sharedList.length > 0 && (
      <div className="shared-table-header">
        <span>Org Name</span>
        <span>Visit Page</span>
        <span>Remove Access?</span>
      </div>
    )}

    {/* Table Rows */}
    {sharedList.length > 0 ? (
      sharedList.map((org) => (
        <div key={org.org_id} className="shared-row">

          <span className="org-name">{org.org_name}</span>

          <div className="visit-icon">
            <img
              src={org.logo || demo}
              alt="logo"
              onError={(e) => (e.target.src = demo)}
            />
            <Button
              variant="text"
              className="visit-page-cta"
              onClick={() => {
                navigate("/organization", { state: { data: org.org_id } });
                dispatch(renderOrganizationInfo({}));
              }}
            >
              VISIT PAGE
            </Button>
          </div>

          <button
            className="delete-btn"
             onClick={() => confirmRemoveAccess(org.org_id)}
          >
            🗑
          </button>
        </div>
      ))
    ) : (
      <p className="no-access-text">No shared access yet</p>
    )}

  </div>

        </div>
      </div>
      {showConfirmPopup && (
  <div className="popup-overlay">
    <div className="popup-content">
      <h3 style={{color:"#446fa2"}}>Are you sure?</h3>
      <p>This organization will lose access.</p>

      <div className="popup-actions">
        <button className="confirm-btn" onClick={handleConfirmDelete}>
          Yes, Remove
        </button>
        <button className="cancel-btn" onClick={handleCancelDelete}>
          Cancel
        </button>
      </div>
    </div>
  </div>
)}

    </div>
  );
};

export default ShareAssetPopup;
